import { Vector3 } from "three";
import { CharacterAnimationController, CharacterAnimationState } from "../animations/CharacterAnimationController";
import { Character } from "../Character";
import { ICharacterState } from "./ICharacterState";
import { CharacterStates } from "./CharacterStates";

export class DieState implements ICharacterState {
    public constructor(
        private readonly character: Character,
        private animationController: CharacterAnimationController,
    ) {
    }

    public enter(): void {
        this.animationController.transitToState(CharacterAnimationState.Death);
    }

    public exit(): void { }

    public process(_dt: number): CharacterStates {
        if (this.character.alive) {
            return CharacterStates.IDLE;
        }
        return CharacterStates.DIE;
    }

    public onInput(value: Vector3): void { }

    public onTakeDamage(): void { }
}
